import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {ProvidersModule} from './providers/providers.module';
import { MatSnackBarModule } from '@angular/material/snack-bar';

import { DatePipe } from '@angular/common';


@NgModule({
  declarations: [
    AppComponent
    
     
    
    
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ProvidersModule.forRoot(),
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    BrowserAnimationsModule,
    MatSnackBarModule
  ],
  providers: [MatSnackBarModule,DatePipe],
  bootstrap: [AppComponent]
})
export class AppModule { }
